import { PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';
import { history } from 'Store';
import ErrorPage from 'Containers/ErrorPage';
import { routes } from 'Constants/routes';

const ErrorFallback = ({ resetError }: { resetError: () => void }): JSX.Element => {
  const onError = (): void => {
    resetError();
  };
  return <ErrorPage onError={onError} />;
};

const ErrorBoundary = ({ children }: PropsWithChildren): JSX.Element => {
  const onReset = (): void => {
    history.push(routes.DASHBOARD);
  };
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} onReset={onReset}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
